"use client"

import type { Tower } from "@/types/tower.types"
import { TOWER_SPRITESHEET, TOWER_SPRITE_COUNT, TOWER_SPRITE_INDEX } from "@/components/game-ui/tower-sprite-index"

const SPRITE_SIZE = 64 // Each portrait is 64x64 pixels

interface TowerPortraitSectionProps {
  tower: Tower
  onDeselectTower?: () => void
  scale: number
}

export const TowerPortraitSection = ({
  tower,
  onDeselectTower,
  scale,
}: TowerPortraitSectionProps) => {
  const effectiveScale = scale > 0 ? scale : 1
  const width = 84 * effectiveScale
  const height = 84 * effectiveScale
  const left = 19 * effectiveScale
  const top = 26 * effectiveScale

  // Get sprite index for this tower type
  const spriteIndex = TOWER_SPRITE_INDEX[tower.type] ?? 0
  const spriteOffsetX = spriteIndex * SPRITE_SIZE

  return (
    <div
      id="tower-portrait-section"
      className="absolute"
      style={{
        left,
        top,
        width,
        height,
      }}
    >
      <button
        id="tower-portrait-button"
        onClick={onDeselectTower}
        className="w-full h-full relative overflow-hidden transition-all hover:brightness-110"
        title="Click to deselect tower"
      >
        {/* Tower portrait from spritesheet */}
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${TOWER_SPRITESHEET})`,
            backgroundPosition: `-${spriteOffsetX * (width / SPRITE_SIZE)}px 0`,
            backgroundSize: `${TOWER_SPRITE_COUNT * width}px ${height}px`,
            imageRendering: "pixelated",
          }}
          aria-label={`${tower.type} tower portrait`}
        />

        {/* Level indicator */}
        <div
          className="absolute bottom-0 right-0 bg-black/70 text-amber-400 font-bold px-1"
          style={{ fontSize: `${10 * effectiveScale}px` }}
        >
          Lv.{tower.level}
        </div>

        {/* Selection indicator - amber pulsing border for towers */}
        <div className="absolute inset-0 border-2 border-amber-400 animate-pulse pointer-events-none" />
      </button>
    </div>
  )
}
